var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ColorPicker',{attrs:{"value":_vm.color},on:{"change":function($event){return _vm.$emit('confirm', $event)}},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('EditorButton',{attrs:{"title":_vm.tooltip}},[_vm._t("default")],2)]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }